import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { rangeByType } from '@/components/CustomCharts/lib';
import moment from 'moment';
import { vendorCurrency } from '@/config/currency';

export default {
  data() {
    return {
      minDate: moment()
        .subtract(13, 'months')
        .startOf('month')
        .toDate(),

      maxDate: moment()
        .subtract(1, 'days')
        .toDate(),
    };
  },

  computed: {
    ...mapState({
      vendor: state => state.vendor,
    }),

    ...mapState('reports_v2', {
      start: state => state.start,
      end: state => state.end,
      granularity: state => state.granularity,
      reports: state => state.reports,
      reportRequests: state => state.requests,
      // Fix chart
      category: state => state.category,
    }),

    ...mapGetters('reports_v2', ['getData', 'requestHash']),
    ...mapGetters('personal', ['getAllPersonalData', 'getPersonalData']),

    currency() {
      return vendorCurrency[this.vendor];
    },

    conditions() {
      return this.getAllPersonalData;
    },

    chartData() {
      return this.getData();
    },

    loading() {
      const request = this.reportRequests[this.requestHash()];
      return request && request.inProgress;
    },
  },
  methods: {
    ...mapActions('reports_v2', {
      newFetchReports: 'fetchGraphData',
      oldFetchReports: 'fetch',
    }),

    fetchReports() {
      // NOTE (EMMA): fetch both monthly and daily data from awsdaily and awsdaily2 tables for now
      // This is because awsmonthly is not equal to awsdaily2
      // Might revert this changes if we are able to fix batch processAcctSummary

      // if (this.granularity.granularity === 'daily') {
      return this.newFetchReports();
      // } else {
      //   return this.oldFetchReports();
      // }
    },

    ...mapMutations('reports_v2', ['updateCondition']),

    ...mapActions('personal', {
      fetchPersonal: 'fetch',
    }),

    async setInitialChartConditions() {
      /**
       * Set chart config from Personalized data.
       * Need API
       */
      const setKeys = ['granularity'];
      setKeys.forEach(i => {
        const value = this.getPersonalData(i);
        this.updateCondition({ key: i, value: value });
      });

      /**
       * Set the initial category dynamically based on resource and vendor.
       */
      const resource = this.$store.state.reports_v2.resource;
      const vendor = this.$store.state.vendor;
      let initialCategory = 'productCode';
    
      if (resource === 'account' || resource === 'group' || resource === 'azure_subscription') {
        if (vendor === 'aws') {
          initialCategory = 'productCode';
        } else if (vendor === 'azure' || vendor === 'gcp') {
          initialCategory = 'service';
        }
      } else if (resource === 'cross_tag' || resource === 'tag') {
        initialCategory = this.owner === 'company' ? 'service' : 'account';
      }
    
      this.updateCondition({ key: 'category', value: initialCategory });
      // console.log("Caregory: ", initialCategory)

      /**
       * Set char range from ...
       */
      const rangeType = this.getPersonalData('defaultRange');
      const range = rangeByType(rangeType, this.maxDate);

      this.updateCondition({ key: 'start', value: range.start });
      this.updateCondition({ key: 'end', value: range.end });
    },

    async initialGenerateChart({ owner, ownerId }) {
      /**
       * Set chart owner
       */
      this.updateCondition({ key: 'owner', value: owner });
      if (ownerId) {
        this.updateCondition({ key: 'ownerId', value: ownerId });
      }
    
      /**
       * Set chart config from Personalized data.
       * Need API
       */
      const setKeys = ['granularity'];
      setKeys.forEach(i => {
        const value = this.getPersonalData(i);
        this.updateCondition({ key: i, value: value });
      });
    
      /**
       * Set the initial category dynamically based on resource and vendor.
       */
      const resource = this.$store.state.reports_v2.resource;
      const vendor = this.$store.state.vendor;
      let initialCategory = 'productCode';  
    
      if (resource === 'account' || resource === 'group' || resource === 'azure_subscription') {
        if (vendor === 'aws') {
          initialCategory = 'productCode';
        } else if (vendor === 'azure' || vendor === 'gcp') {
          initialCategory = 'service';
        }
      } else if (resource === 'cross_tag' || resource === 'tag') {
        initialCategory = this.owner === 'company' ? 'service' : 'account';
      }
    
      this.updateCondition({ key: 'category', value: initialCategory });
    
      /**
       * Set chart range from Personalized data or defaults.
       */
      const rangeType = this.getPersonalData('defaultRange');
      const range = rangeByType(rangeType, this.maxDate);
    
      this.updateCondition({ key: 'start', value: range.start });
      this.updateCondition({ key: 'end', value: range.end });
    
      /**
       * Set chart config from User data.
       */
      this.updateCondition({ key: 'vendor', value: this.vendor });
    
      /**
       * Fetch chart data.
       * Generate chart.
       */
      await this.fetchReports();

      this.$refs['hero-chart'].initialGenerateChart();
    
      return Promise.resolve();
    },    

    async onUpdateDateRange(range) {
      this.updateCondition({ key: 'start', value: range.start });
      this.updateCondition({ key: 'end', value: range.end });

      await this.fetchReports();
      if (this.$refs['hero-chart']) {
        this.$refs['hero-chart'].setInitialSeries();
        this.$refs['hero-chart'].generateChart();
      }
    },

    async onUpdateGranularity(value) {
      this.updateCondition({ key: 'granularity', value });

      // Case: daily
      // APIがデータレンジ2ヶ月間しかサポートしていないため、月別から日別に変えた際、
      // 2ヶ月以上のレンジの場合は自動で2ヶ月間に変更する。
      if (value === 'daily') {
        let start = this.start;
        const end = this.end;
        if (moment(end).diff(start, 'months', true) > 2) {
          start = moment(end)
            .subtract(2, 'month')
            .add(1, 'day');
          this.updateCondition({ key: 'start', value: start });
        }
      }

      await this.fetchReports();
      this.$refs['hero-chart'].setInitialSeries();
      this.$refs['hero-chart'].generateChart();
    },

    // async onUpdateCategory(value) {
    //   this.updateCondition({ key: 'category', value });

    //   await this.fetchReports();
    //   this.$refs['hero-chart'].setInitialSeries();
    //   this.$refs['hero-chart'].generateChart();
    // },

    async onUpdateCategory(value) {
      try {
        const previousCategory = this.$store.state.reports_v2.category;

        // Update category
        this.updateCondition({ key: 'category', value });

        // If switching from tags, clear tag-specific state
        if (previousCategory === 'tags' && value !== 'tags') {
          await this.$store.dispatch('reports_v2/setSelectedTagKey', null);
        }

        await this.fetchReports();

        // Update chart
        if (this.$refs['hero-chart']) {
          await this.$nextTick();
          this.$refs['hero-chart'].setInitialSeries();
          this.$refs['hero-chart'].generateChart();
        }
      } catch (error) {
        console.error('Error updating category:', error);
      }
    },

    async onUpdateResourceType(value) {
      this.updateCondition({ key: 'resource', value });
      await this.fetchReports();
      this.$refs['hero-chart'].setInitialSeries();
      this.$refs['hero-chart'].generateChart();
    },

    async onChangeSettingSuccess({ owner, ownerId }) {
      await this.fetchPersonal();
      await this.initialGenerateChart({ owner, ownerId });
    },
  },
};
